import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { RolesFilterOption } from '../../models/role-filter-option';
import { RoleRegister } from '../../role-register';
import * as RoleRegisterActions from '../../state/role-register.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-role-register',
    templateUrl: './account-role-register.component.html',
    standalone: false
})
export class AccountRoleRegisterComponent extends RoleRegister {
   constructor(public store: Store) {
      super(store);
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: RolesFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters: RolesFilterOption[]) => {
            this.filters = filters;
            this.columns = ['name', 'description', 'roleUserCount', 'accountRoleActionsMenu'];
         });
   }

   onCreate(): void {
      this.store.dispatch(RoleRegisterActions.createRole());
   }
}
